import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@dynamon-as/ui';
import LoginIcon from '@mui/icons-material/Login';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { saveRedirectPath } from '@features/auth/utils';
import { getAuth0Config } from '@features/auth/constants';
import styles from './Login.module.css';

const Login = (): React.ReactElement => {
    const { loginWithRedirect } = useAuth0();
    const location = useLocation();

    useEffect((): void => {
        // If we're on the login page, check if there's a redirect path in query params
        // This handles the case where user was redirected from a protected route
        const searchParams = new URLSearchParams(location.search);
        const redirectPath = searchParams.get('redirect_to');

        if (redirectPath) {
            saveRedirectPath(redirectPath);
        }
    }, [location.search]);

    const handleLogin = async (): Promise<void> => {
        // Save the current path (login page) so we redirect to home after auth
        // This ensures consistent behavior: always go to root after login
        saveRedirectPath('/');

        // Get the redirect URI from Auth0 config
        const config = getAuth0Config();

        await loginWithRedirect({
            authorizationParams: {
                scope: 'openid profile email',
                ui_locales: 'nb',
                redirect_uri: config.authorizationParams.redirect_uri,
            },
        });
    };

    return (
        <div className={styles.container}>
            <img
                src="/images/logo-orange.svg"
                alt="Dynamon"
                className={styles.logo}
            />
            <h1 className={styles.title}>Dynamon Employee Portal</h1>
            <Button
                variant="normal"
                size="large"
                onClick={handleLogin}
                Icon={LoginIcon}
                text="Logg inn"
            />
        </div>
    );
};

export default Login;
